import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
// import { formatearNumeroEntero } from '../../funciones_globales/format';
import { formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import { cargarCatalogos } from '../../funciones_globales/catalogos';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
class FormInven15 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            tipo_reporte_seleccionado:'D',//EXISTEN LOS SIGUIENTES TIPO DE REPORTE, 'C'->Consolidado, 'B'->Bodega Central, 'O'->Otras Bodegas
            fechaDesde: null,
            fechaHasta: null,
            bodegas: [],
            bodega_sel: undefined,
            usuario:'',
            mostrarContabilidad:false,
            localidad:'01'
            
        };
       
        this.limpiar = this.limpiar.bind(this);        
        this.generarReporte = this.generarReporte.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onGridReady = this.onGridReady.bind(this);   
    }

    handleInputChange(event) {
        const target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
          [name]: value
        });
    }
    onGridReady(params) {
        this.api = params.api;
        this.columnApi = params.columnApi;
      }
    componentDidMount(){
        Promise.all([
            cargarCatalogos('BODEGA'),
            getItemDatosSesion('usuario'),
            this.props.generar_LogAuditoriaIngresoForm('0215')
         ]).then(([bodegas, usuario]) => {
        
            this.setState({bodegas:bodegas, usuario:usuario})
         });
       
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0215');
    }
    generarReporte(tipoRpt){       
        try {

            //validacion de fechas
            //Validacion formato fecha
            var urlReportWithParams='';
            var continuar = true;
            if(this.state.fechaDesde){
                if(this.state.fechaDesde.isValid()===false){
                    continuar=false;
                    alert('La fecha desde no es correcta.');
                    return;
                }
            }else{
                continuar=false;
                alert('La fecha desde no se encuentra ingresada.');
                return;
            }

            if(this.state.fechaHasta){
                if(this.state.fechaHasta.isValid()===false){
                    continuar=false;
                    alert('La fecha hasta no es correcta.');
                }
            }else{
                continuar=false;
                alert('La fecha hasta no se encuentra ingresada.');
            }
            if(this.state.bodega_sel===null || this.state.bodega_sel===undefined){
                continuar=false;
                alert('Debe seleccionar una bodega para continuar...');
                return;
            }
            //Se procede a guardar el reporte que se genera
            if(continuar){
                console.log(this.state.bodega_sel)
                console.log(this.state.fechaDesde)
                console.log(this.state.fechaHasta)
                console.log(this.state.tipo_reporte_seleccionado)
                if(this.state.tipo_reporte_seleccionado==='D'){
                    if(this.state.mostrarContabilidad){
                        //Reporte Detallado
                        urlReportWithParams += `&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}&param2=${ formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}&param3=${this.state.bodega_sel}&param4=${this.state.localidad}`;
                        urlReportWithParams =`&rpt=126`.concat(urlReportWithParams);
                    }else{
                        //Reporte Detallado
                        urlReportWithParams += `&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}&param2=${ formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}&param3=${this.state.bodega_sel}&param4=${this.state.localidad}`;
                        urlReportWithParams =`&rpt=124`.concat(urlReportWithParams);
                    }
                  
                }else{
                    //Reporte Resumido
                    urlReportWithParams += `&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}&param2=${ formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}&param3=${this.state.bodega_sel}&param4=${this.state.localidad}`;
                    urlReportWithParams =`&rpt=125`.concat(urlReportWithParams);
                }
               
                 visualizarReporteEnPdf(urlReportWithParams);
            }
            
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){
        console.log("HOAAA PILAS")
        this.setState({  
        mostrarTodos:false,
        bodega_sel:undefined,
        bloqueaBodega:false
        })
        
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
            <HeaderForm>
                <TituloForm>Transacciones de Inventario</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={15}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo Reporte:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-12'>					
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipo_reporte_seleccionado' value='D' checked={this.state.tipo_reporte_seleccionado==='D'} onChange={this.handleInputChange} />
                                Detallado
                            </LabelForm>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipo_reporte_seleccionado' value='R' checked={this.state.tipo_reporte_seleccionado==='R'} onChange={this.handleInputChange} />
                               Resumido
                            </LabelForm>   
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='8'>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4' margen_arriba='15' margen_abajo='4'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>  
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='8'>
                            <LabelForm>Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4' margen_arriba='15' margen_abajo='8'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                   
                    <Row>
                        <ContainerCol className='col-sm-6' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Bodega:</LabelForm>
                            <ReactSelect disabled={this.state.bloqueaBodega} options={ this.state.bodegas } value={this.state.bodega_sel} func_onChange={(value)=>{this.setState({bodega_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>
                    </Row>
                    {
                        this.state.tipo_reporte_seleccionado==='D'?
                        <Row>
                            <ContainerCol className='col-sm-6' margen_abajo='4'>
                                <LabelForm><input type='checkbox' name='mostrarContabilidad' checked={this.state.mostrarContabilidad} 
                                onChange={this.handleInputChange}/> Transacciones de contabilidad </LabelForm>
                            </ContainerCol>                      
                        </Row>
                        :
                        null
                    }
                    
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-info btn-sm' onClick={()=>{this.generarReporte('PDF')}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,cambiar_VisualizacionLoading}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormInven15);